import React, { useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Modal } from "../../components";

const GameListModal = (props) => {
  const [checked, setChecked] = useState("1");
  let { gameListModal, onBackdropClick, handelNo, handelStatusData } = props;
  return (
    <Modal
      classCustom="2xl:w-[20%] xl:w-[20%] lg:w-[25%] md:w-[45%] w-[50%]"
      open={gameListModal}
      onBackdropClick={onBackdropClick}
    >
      <div className="bg-white  border-3 border-[#FEBB13]">
        <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
          <h3></h3>
          <h3 className="text-[#FFFFFF] ml-4 font-semibold text-lg">
            Game lists
          </h3>
          <XCircleIcon
            onClick={handelNo}
            className="w-7 h-7 cursor-pointer "
            color="white"
          />
        </div>
        <div className="px-10 my-6">
          <div className="flex justify-center items-center mt-6">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={checked}
                onChange={(e) => {
                  setChecked(e.target.value);
                  handelStatusData(
                    e.target.value === "3" ? "1" : e.target.value,
                    e.target.value === "3"
                      ? [
                          {
                            columnName: "userLockStatus",
                            columnType: "text",
                            type: "_e",
                            value: "t",
                            conditionOp: "and",
                          },
                        ]
                      : []
                  );
                  handelNo();
                }}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="All Candidates"
                />

                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Game in Progress"
                />
                <FormControlLabel
                  value="3"
                  control={<Radio />}
                  label="Locked Games"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GameListModal;
